<template>
<div class="chapter">
<div class="inner_page">
<div class="section" id="contents">
<h2 class="calibre9" id="calibre_pb_2">Contents</h2>
<table class="calibre10" summary="">
<tbody class="calibre11"><tr class="calibre12">
<td class="n">I.</td>
<td class="t"><a href="#/Text/Section0003#ch01">The Hackleton Case</a></td>
</tr>
<tr class="calibre12">
<td class="n">II.</td>
<td class="t"><a href="#/Text/Section0004#ch02">The Affair in the Maze</a></td>
</tr>
<tr class="calibre12">
<td class="n">III.</td>
<td class="t"><a href="#/Text/Section0005#ch03">The Immediate Results</a></td>
</tr>
<tr class="calibre12">
<td class="n">IV.</td>
<td class="t"><span href="#/Text/Section0006#ch04" title="Link target outside of Sample">The Chief Constable</span></td>
</tr>
<tr class="calibre12">
<td class="n">V.</td>
<td class="t"><span href="#/Text/Section0007#ch05" title="Link target outside of Sample">The Evidence in the Case</span></td>
</tr>
<tr class="calibre12">
<td class="n">VI.</td>
<td class="t"><span href="#/Text/Section0008#ch06" title="Link target outside of Sample">The Toxicologist</span></td>
</tr>
<tr class="calibre12">
<td class="n">VII.</td>
<td class="t"><span href="#/Text/Section0009#ch07" title="Link target outside of Sample">The Pot of Curare</span></td>
</tr>
<tr class="calibre12">
<td class="n">VIII.</td>
<td class="t"><span href="#/Text/Section0010#ch08" title="Link target outside of Sample">Opportunity, Method, and Motive</span></td>
</tr>
<tr class="calibre12">
<td class="n">IX.</td>
<td class="t"><span href="#/Text/Section0011#ch09" title="Link target outside of Sample">The Burglary at Whistlefield</span></td>
</tr>
<tr class="calibre12">
<td class="n">X.</td>
<td class="t"><span href="#/Text/Section0012#ch10" title="Link target outside of Sample">The Third Attack in the Maze</span></td>
</tr>
<tr class="calibre12">
<td class="n">XI.</td>
<td class="t"><span href="#/Text/Section0013#ch11" title="Link target outside of Sample">The Squire’s Theories</span></td>
</tr>
<tr class="calibre12">
<td class="n">XII.</td>
<td class="t"><span href="#/Text/Section0014#ch12" title="Link target outside of Sample">The Fourth Attack</span></td>
</tr>
<tr class="calibre12">
<td class="n">XIII.</td>
<td class="t"><span href="#/Text/Section0015#ch13" title="Link target outside of Sample">The Dart</span></td>
</tr>
<tr class="calibre12">
<td class="n">XIV.</td>
<td class="t"><span href="#/Text/Section0016#ch14" title="Link target outside of Sample">The Forged Cheque</span></td>
</tr>
<tr class="calibre12">
<td class="n">XV.</td>
<td class="t"><span href="#/Text/Section0017#ch15" title="Link target outside of Sample">The Secretary’s Affairs</span></td>
</tr>
<tr class="calibre12">
<td class="n">XVI.</td>
<td class="t"><span href="#/Text/Section0018#ch16" title="Link target outside of Sample">The Last Attack in the Maze</span></td>
</tr>
<tr class="calibre12">
<td class="n">XVII.</td>
<td class="t"><span href="#/Text/Section0019#ch17" title="Link target outside of Sample">The Siege of the Maze</span></td>
</tr>
<tr class="calibre12">
<td class="n">XVIII.</td>
<td class="t"><span href="#/Text/Section0020#ch18" title="Link target outside of Sample">The Truth of the Matter</span></td>
</tr>
</tbody>
</table>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?49807232